<div class="content-style-class">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="column">
      <abc-button
        class="side-by-side return-button"
        stylingMode="text"
        icon="back"
        type="default"
        [hoverStateEnabled]="false"
        (onClick)="backToSubProjectList()"
      >
      </abc-button>
      <h2 class="title-style">
        {{ dataService.res("Ubt-SubProject-SubProjectReport") }}
      </h2>
    </div>
    <div fxLayout="row" fxLayoutAlign="end center">
      <div>
        <abc-button
          stylingMode="text"
          icon="chevronleft"
          type="default"
          (onClick)="goToNext(-1)"
          class="btn-navigation"
          [disabled]="this.appService.currentSubProjectIndex === 0"
          [hoverStateEnabled]="false"
        >
        </abc-button>
      </div>
      <div>
        <abc-button
          stylingMode="text"
          class="btn-navigation"
          icon="chevronnext"
          type="default"
          (onClick)="goToNext(1)"
          [disabled]="
            this.appService.currentSubProjectIndex ===
            this.appService.subProjectIds?.length - 1
          "
          [hoverStateEnabled]="false"
        >
        </abc-button>
      </div>
    </div>
  </div>
  <div #swipeMe class="content-block sub-project-container">
    <div class="dx-card responsive-paddings">
      <abc-gallery
        #galleryContainer
        [dataSource]="reports"
        height="100%"
        width="100%"
        [loop]="true"
        [showIndicator]="false"
        [showNavButtons]="false"
        [swipeEnabled]="false"
      >
        <div
          class="gallery-item-overflow"
          fxFill
          *dxTemplate="let galleryItem of 'item'"
        >
          <div fxLayoutAlign="space-between" class="gallery-item-label">
            <span class="sub-title-style">
              {{ galleryItem.subProjectLabel }}
            </span>
          </div>
          <div class="content-block">
            <div class="dx-card responsive-paddings card-radius">
              <dx-data-grid
                #subProjectReport
                id="subProjectReport"
                class="grid-group-by-Style custome-export-style grid-adaptive-mode"
                [showRowLines]="true"
                (onCellClick)="onCellClick($event)"
                (onCellPrepared)="onCellPrepared($event)"
                [columns]="columnsHeader"
                [showBorders]="true"
                [dataSource]="reports"
                width="100%"
                height="100%"
                [noDataText]="dataService.res('Ubt-NoData-message')"
                [rowAlternationEnabled]="false"
                [allowColumnReordering]="false"
                [columnHidingEnabled]="true"
                [wordWrapEnabled]="true"
                [columnAutoWidth]="false"
              >
                <dxo-summary>
                  <dxi-total-item
                    column="totalTime"
                    summaryType="sum"
                    valueFormat="#,##0 h"
                    displayFormat="{{
                      dataService.res('Ubt-Report-Total')
                    }}: {0}"
                  >
                  </dxi-total-item>
                  <dxi-total-item
                    column="executedTime"
                    summaryType="sum"
                    valueFormat="#,##0 h"
                    displayFormat="{{
                      dataService.res('Ubt-Report-Total')
                    }}: {0}"
                  >
                  </dxi-total-item>
                </dxo-summary>
                <div *dxTemplate="let progress of 'progressCellTemplate'">
                  <div class="chart-cell">
                    <dx-bullet
                      [showTarget]="false"
                      [showZeroLevel]="true"
                      [startScaleValue]="0"
                      [color]="'var(--primary-color)'"
                      [endScaleValue]="100"
                      [value]="progress.value"
                    >
                      <dxo-size [width]="'auto'" [height]="26"></dxo-size>
                      <dxo-tooltip
                        [enabled]="true"
                        [paddingTopBottom]="2"
                        [customizeTooltip]="customizeTooltip"
                      >
                        <dxo-font [size]="18"></dxo-font>
                      </dxo-tooltip>
                      <dxo-margin
                        [top]="5"
                        [bottom]="0"
                        [left]="5"
                      ></dxo-margin>
                    </dx-bullet>
                  </div>
                </div>
              </dx-data-grid>
            </div>
          </div>
          @if (showReportsDetails == true) {
            <div fxLayout="row" fxLayout.lt-md="column" class="Reports-details">
              <div fxFlex="49" fxLayout="column">
                <h2 class="progress-title">
                  {{ dataService.res("Ubt-MeasureDetail-Progress") }}
                </h2>
                <div class="cyan"></div>
                @for (item of reports; track item) {
                  <div class="ellipsis">
                    @if (item.progress) {
                      <div>
                        <div
                          fxLayout="column"
                          class="measure-title"
                          fxFlex="35"
                          fxLayoutAlign="start none"
                        >
                          {{ item.measureTitle }}:
                        </div>
                        <div fxLayout="column" class="ellipsis" fxFlex="65">
                          <dx-html-editor
                            class="description-html-editor"
                            [readOnly]="true"
                            [value]="item.progress"
                          ></dx-html-editor>
                        </div>
                      </div>
                    }
                    @if (item.progress) {
                      <div class="border-bottom-style"></div>
                    }
                  </div>
                }
              </div>
              <div fxLayout="column" fxFlex="1"></div>
              <div fxFlex="49" fxLayout="column">
                <h2 class="progress-title">
                  {{ dataService.res("Ubt-MeasureDetail-Next-Steps") }}
                </h2>
                <div class="cyan"></div>
                @for (item of reports; track item) {
                  <div class="ellipsis">
                    @if (item.nextSteps) {
                      <div>
                        <div
                          fxLayout="column"
                          class="measure-title"
                          fxFlex="35"
                          fxLayoutAlign="start none"
                        >
                          {{ item?.measureTitle }}:
                        </div>
                        <div fxLayout="column" class="ellipsis" fxFlex="65">
                          <dx-html-editor
                            class="description-html-editor"
                            [readOnly]="true"
                            [value]="item.nextSteps"
                          ></dx-html-editor>
                        </div>
                      </div>
                    }
                    @if (item.nextSteps) {
                      <div class="border-bottom-style"></div>
                    }
                  </div>
                }
              </div>
            </div>
          }
          @if (showReportsDetails == true) {
            <div fxLayout="row" fxLayout.lt-md="column" class="Reports-details">
              <div fxFlex="49" fxLayout="column">
                <h2 class="progress-title">
                  {{
                    dataService.res("Ubt-MeasureDetail-Decision-Clarification")
                  }}
                </h2>
                <div class="cyan"></div>
                @for (item of reports; track item) {
                  <div class="ellipsis">
                    @if (item.decision) {
                      <div>
                        <div
                          fxLayout="column"
                          class="measure-title"
                          fxFlex="35"
                          fxLayoutAlign="start none"
                        >
                          {{ item?.measureTitle }}:
                        </div>
                        <div fxLayout="column" class="ellipsis" fxFlex="65">
                          <dx-html-editor
                            class="description-html-editor"
                            [readOnly]="true"
                            [value]="item.decision"
                          ></dx-html-editor>
                        </div>
                      </div>
                    }
                    @if (item.decision) {
                      <div class="border-bottom-style"></div>
                    }
                  </div>
                }
              </div>
              <div fxLayout="column" fxFlex="1"></div>
              <div fxFlex="49" fxLayout="column">
                <h2 class="progress-title">
                  {{ dataService.res("Ubt-MeasureDetail-Risks-Opportunities") }}
                </h2>
                <div class="cyan"></div>
                @for (item of reports; track item) {
                  <div class="ellipsis">
                    @if (item.riskAndChance) {
                      <div>
                        <div
                          fxLayout="column"
                          class="measure-title description-html-editor"
                          fxFlex="35"
                          fxLayoutAlign="start none"
                        >
                          {{ item?.measureTitle }}:
                        </div>
                        <div fxLayout="column" class="ellipsis" fxFlex="65">
                          <dx-html-editor
                            class="description-html-editor"
                            [readOnly]="true"
                            [value]="item.riskAndChance"
                          ></dx-html-editor>
                        </div>
                      </div>
                    }
                    @if (item.riskAndChance) {
                      <div class="border-bottom-style"></div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </abc-gallery>
    </div>
  </div>
</div>
